import { apiConfigService } from "../../config/api.config";
import { responseHandler } from "../../shared/helpers";
import { AbstractService } from "../../shared/service/abstract-service.service";
import { UserLoginDTO } from "./authentication.model";

// export async function LoginUser(payload: UserLoginDTO) {
//   const response = await apiConfigService.loginRequest().post("auth/sign-in/artiste", payload);
//   const output = responseHandler(response);
//   return output;
// }

// export async function VerifyToken() {
//   const response = await apiConfigService.request().post("auth/me");
//   const output = responseHandler(response);
//   return output;
// }

export class AuthService extends AbstractService {
  resource = "auth";

  async login(payload: UserLoginDTO) {
    return await this.post("sign-in/artiste", payload);
  }

  async verifyToken() {
    return await this.get("me");
  }

  async verifyAccount(payload: { identifiers: string[]; code: string }) {
    return await this.post("verify-account", payload);
  }

  async register(payload: any) {
    return await this.post("sign-up/artiste", payload);
  }

  async forgotPassword(payload: { identifier: string }) {
    return await this.post("forgot-password", payload);
  }

  async resetPassword(payload: any) {
    return await this.post("reset-password", payload);
  }

  async changePassword(payload: any) {
    return await this.post("change-password", payload);
  }

  async updateProfile(payload: any) {
    return await this.post("update-profile", payload);
  }

  async updateProfilePicture(payload: any) {
    return await this.post("update-profile-picture", payload);
  }

  async sendOTP(payload: { identifiers: string[]; useEmail?: boolean }) {
    return await this.post("send-otp", payload);
  }

  async verifyOTP(payload: { identifier: string; code: string; shadow?: boolean }) {
    return await this.post("verify-otp", payload);
  }
}

export const authService = new AuthService();
